import React, { useEffect, useState } from "react";
import { updateDoc, doc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const Customer = () => {
const [bookingToReview, setBookingToReview] = useState(null);
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [showReview, setShowReview] = useState(false);
  const [reviewText, setReviewText] = useState("");

  useEffect(() => {
    if (!auth.currentUser) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const fetchBookings = async () => {

      const q = query(
        collection(db, "bookings"),
        where("userId", "==", auth.currentUser.uid)
      );

      const querySnapshot = await getDocs(q);

      const userBookings = [];
      const today = new Date();
      querySnapshot.forEach((docSnap) => {

  const data = docSnap.data();

  console.log("Booking Data:", data);

  userBookings.push({ id: docSnap.id, ...data });

  if (data.reviewDueDate) {

    const dueDate = data.reviewDueDate.toDate();

    console.log("Today:", today);
    console.log("Review Due Date:", dueDate);

  }

  if (
    data.reviewSubmitted === false &&
    data.reviewDueDate &&
    today >= data.reviewDueDate.toDate()
  ) {
    console.log("Showing review popup");
    setBookingToReview(docSnap.id);
    setShowReview(true);
  }

});

    setBookings(userBookings);

  };

  fetchBookings();

}, []);

  const submitReview = async () => {

    if (!reviewText) {
      alert("Please enter review");
      return;
    }

    await addDoc(collection(db, "reviews"), {
      bookingId: bookingToReview,
    userId: auth.currentUser.uid,
    type: "service",
    review: reviewText,
    createdAt: new Date()
    });
    await updateDoc(doc(db, "bookings", bookingToReview), {
  reviewSubmitted: true
});
    alert("Thank you for your review ");
    setShowReview(false);
    setReviewText("");
    
  };

  return (
    <div className="container " >

      <h2 className="mb-5" style={{marginTop:"6.0em"}}>
        Welcome {auth.currentUser?.displayName}
      </h2>

      <h4>Your Booked Services</h4>

      <table className="table table-bordered mt-3">
        <thead className="table-dark">
          <tr>
            <th>Service</th>
            <th>Mobile</th>
            <th>Address</th>
            <th>Amount</th>
            <th>Booking Date</th>
            <th>Warranty Date</th>
          </tr>
        </thead>
        <tbody>
          {bookings.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No bookings found
              </td>
            </tr>
          ) : (
            bookings.map((booking) => (
              <tr key={booking.id}>
                <td>{booking.servicesBooked.join(", ")}</td>
                <td>{booking.mobileNumber}</td>
                <td>{booking.address}</td>
                <td>₹{booking.totalAmount}</td>
                <td>{booking.bookingDate}</td>
                <td>{booking.warrantyDate}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* ⭐ Review Popup */}
      {showReview && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h5>How was your service?</h5>

            <textarea
              className="form-control mt-2"
              rows="3"
              placeholder="Write your review..."
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
            />

            <button
              className="btn btn-success w-100 mt-3"
              onClick={submitReview}
            >
              Submit Review
            </button>

            <button
              className="btn btn-outline-danger w-100 mt-2"
              onClick={() => setShowReview(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Customer;